// extracted by mini-css-extract-plugin
export default {"MobileMenu":"MobileMenu_MobileMenu__+hV+T","MobileMenu__list":"MobileMenu_MobileMenu__list__H5Yiq","MobileMenu__link":"MobileMenu_MobileMenu__link__5oYfj"};